import LinearGradientCard from '@/components/linear-gradient-card';
import { useSessionContext } from '@/contexts/session/context';
import { useShareQrCodeModal } from '@/components/qr-code/share-qr-code-modal/useShareQrCodeModal';
import BannerBg from '../components/bannerBg';
import PersonalNav from '../components/personalNav';
import FooterActions from '../components/footerActions';
import styles from './index.module.scss';
import ShareIcon from './images/share.svg?react';
import MoreIcon from './images/more.svg?react';
import IDIcon from './images/id.svg?react';

const ProfileInfo = () => {
  const { showProfileInfo, setShowProfileInfo } = useSessionContext();
  const { show, info } = showProfileInfo;
  const [messageApi, contextHolder] = message.useMessage();

  const { setOpen, shareQrCodeModal, groupShareLink } = useShareQrCodeModal({
    messageApi,
    apiParam: {
      user_id: info?.userId,
    },
  });

  useEffect(() => {
    if (info?.userId) {
      groupShareLink();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [info?.userId]);

  return (
    <>
      <Modal
        width={472}
        className={styles.profileCenterModal}
        title="Profile"
        footer={null}
        open={show}
        maskClosable={false}
        onCancel={() => {
          setShowProfileInfo({ show: false });
        }}
      >
        <div className={cls(styles.main, 'scrollbar_hover')}>
          <BannerBg />
          <div className={styles.content}>
            <div className={styles.infoWrap}>
              <div className={styles.avatarWrap}>
                <MyAvatar
                  className={styles.avatar}
                  showProfileClick={false}
                  src={info.avatar!}
                />
              </div>
              <div className={styles.info}>
                <div className={styles.infoTop}>
                  <div className={styles.name}>{info.name}</div>
                </div>
                <div className={styles.infoBottom}>
                  <div className={styles.id}>@{info.username}</div>
                  <div className={styles.label}>
                    <IDIcon />
                  </div>
                </div>
              </div>
            </div>
            <LinearGradientCard className={styles.gradientCard}>
              <div className={styles.section}>
                <div className={styles.badges}></div>
                <div className={styles.stats}>
                  <div className={styles.stat}>
                    <span className={styles.num}>0</span>
                    <div className={styles.label}>followers</div>
                  </div>
                  <div className={styles.stat}>
                    <span className={styles.num}>0</span>
                    <div className={styles.label}>following</div>
                  </div>

                  <div className={styles.stat}>
                    <span className={styles.num}>0</span>
                    <div className={styles.label}>likes</div>
                  </div>
                  <div className={styles.stat}>
                    <span className={styles.num}>0</span>
                    <div className={styles.label}>Gifts</div>
                  </div>
                </div>
                <div className={styles.bio}>This is has no bio.</div>
                {/* <div>
                <div>Contribution</div>
                <div>Guardians</div>
              </div> */}
              </div>
            </LinearGradientCard>
            {/* <div >
            <div>Gift Showcase</div>
            <div>Join Fan Club</div>
            <div>Hot Picks</div>
          </div> */}
            <PersonalNav></PersonalNav>
          </div>
        </div>
        <div className={styles.actions}>
          <div
            onClick={() => {
              setShowProfileInfo({ show: false });
              setOpen(true);
            }}
          >
            <ShareIcon />
          </div>
          <div>
            <MoreIcon />
          </div>
        </div>
        <FooterActions info={info} />
      </Modal>
      {contextHolder}
      {shareQrCodeModal({
        headerAvatar: info?.avatar ?? '',
        headerName: info?.name ?? '',
        shortName: info?.username ?? '',
      })}
    </>
  );
};

export default ProfileInfo;
